
import { Alert } from "@/components/ui/alert";
import { User } from "@supabase/supabase-js";
import { useAuth } from "@/contexts/auth";

interface InsightAuthAlertsProps {
  user: User | null;
  canVote: (poll?: any) => boolean;
  poll?: any;
}

const InsightAuthAlerts = ({ user, canVote, poll }: InsightAuthAlertsProps) => {
  const { profile } = useAuth();

  if (!user) {
    // Check if anonymous voting is allowed for this poll
    if (poll?.anonymous_allowed) {
      return (
        <Alert className="my-4">
          <p>You can vote anonymously on this poll, or sign in for a verified vote</p>
        </Alert>
      );
    } else {
      return (
        <Alert className="my-4">
          <p>Sign in to vote on this poll</p>
        </Alert>
      );
    }
  }

  if (!canVote(poll)) {
    // Provide specific messaging based on user role and poll settings
    if (profile?.role === 'public' && !poll?.public_voting_allowed) {
      return (
        <Alert className="my-4">
          <p>Public voting is not enabled for this poll</p>
        </Alert>
      );
    } else if (profile?.role === 'pollster' && !profile?.verified) {
      return (
        <Alert className="my-4">
          <p>You need to be a verified pollster to vote on polls</p>
        </Alert>
      );
    } else {
      return (
        <Alert className="my-4">
          <p>You don't have permission to vote on this poll</p>
        </Alert>
      );
    }
  }

  return null;
};

export default InsightAuthAlerts;
